import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import RangeSliderBorderRadius from "../../../UI/RangeSliderBorderRadius";
import {
  AlignHorizontalJustifyStart,
  AlignHorizontalJustifyEnd,
  AlignVerticalJustifyStart,
  AlignVerticalJustifyEnd,
  AlignHorizontalSpaceBetween,
  AlignHorizontalSpaceAround,
 
  AlignHorizontalJustifyCenter,
  AlignHorizontalDistributeCenter,
  AlignVerticalJustifyCenter,
  AlignVerticalDistributeCenter,
  AlignVerticalSpaceBetween,
  ArrowRightFromLine,
  WrapText,
  Undo2,
 
} from "lucide-react";
import {
  AlignVerticalSpaceAround,
  AlignVerticalJustifyStretch,
} from "lucide-react";
const ItemSelectBoxesBigUI =  ({ itemsArray, callbackItemValue, objectValue,objectName,displayName ,}) => {
  const [items ,setItems] =useState(itemsArray);

 const flexDirectionIcons = {
  "row": <AlignHorizontalJustifyStart size={28} color="#666" />,
  "row-reverse": <AlignHorizontalJustifyEnd size={28} color="#666" />,
  "column": <AlignVerticalJustifyStart size={28} color="#666" />,
  "column-reverse": <AlignVerticalJustifyEnd size={28} color="#666" />
};
const justifyContentIcons = {
  "flex-start": <AlignHorizontalJustifyStart size={28} color="#666" />,
  "flex-end": <AlignHorizontalJustifyEnd size={28} color="#666" />,
  "center": <AlignHorizontalJustifyCenter size={28} color="#666" />,
  "space-between": <AlignHorizontalSpaceBetween size={28} color="#666" />,
  "space-around": <AlignHorizontalSpaceAround size={28} color="#666" />,
  "space-evenly": <AlignHorizontalDistributeCenter size={28} color="#666" />
};
const alignItemsIcons = {
  "flex-start": <AlignVerticalJustifyStart size={28} color="#666" />,
  "flex-end": <AlignVerticalJustifyEnd size={28} color="#666" />,
  "center": <AlignVerticalJustifyCenter size={28} color="#666" />,
  "stretch": <AlignVerticalSpaceBetween size={28} color="#666" />,  // use AlignVerticalJustifyStretch if available
  "baseline": <AlignVerticalDistributeCenter size={28} color="#666" /> // fallback to a generic if this isn't available
};
const alignContentIcons = {
  "flex-start": <AlignVerticalJustifyStart size={28} color="#666" />,
  "flex-end": <AlignVerticalJustifyEnd size={28} color="#666" />,
  "center": <AlignVerticalJustifyCenter size={28} color="#666" />,
  "stretch": <AlignVerticalSpaceBetween size={28} color="#666" />,
  "space-between": <AlignVerticalDistributeCenter size={28} color="#666" />,
  "space-around": <AlignVerticalSpaceAround size={28} color="#666" />
};
const wrapIcons = {
  "nowrap": <ArrowRightFromLine size={28} color="#666" />,           // or anything that suggests a single line
  "wrap": <WrapText size={28} color="#666" />,             // line wrap icon
  "wrap-reverse": <Undo2 size={28} color="#666" />         // represents reverse flow (you can change to another icon)
};
     const dispatch = useDispatch();  
     const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
            {
              
              dispatch({type: "CURSOR",payload:true  });
          
              dispatch({type: "CURSORTEXT",payload:CursorText})
              dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
              dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
            }
             
            const handleMouseLeave = () => {
              
              dispatch({type: "CURSOR",payload:false})
          
              dispatch({type: "CURSORTEXT",payload:""})
          
              dispatch({type: "CURSORTEXTBG",payload:""})
              dispatch({type: "CURSORTEXTCOLOR",payload:""})
            
          
          }
 const [itemValue, setItemValue] = useState(objectValue);

 return(<>


                                    <div  style={{display:"flex",justifyContent:"space-around"}}>
                                               <h4>{displayName} </h4>
           <div > 
            <div class="input-card-outer"style={{
                 
                  transition: 'transform 3s ease, opacity 3s ease',
                borderRadius:"25px",padding:"0px"}} >
                                          
                                          <div  style={{display:"flex",justifyContent:"left"}}>
                                                {items?.map((item,index)=>(
                                                 <> {index<2? 
                                                 
                                                 
                                            
                        
                           <label onMouseEnter={
                                                      ()=>handleMouseEnter("#fff","#333",item)}
                                       onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{paddingTop:"15px"}}>
                                                      <div style={{display:"flex",flexDirection: "row",gap:"5px",}} >
                                                       <div style={{display:"flex",justifyContent:"center"}}>
                                                     {
                                              objectName=="flexDirection"?flexDirectionIcons[item]:
                                              objectName=="justifyContent"?justifyContentIcons[item] :
                                              objectName=="alignItems"?alignItemsIcons[item]:
                                              objectName=="alignContent"?alignContentIcons[item]:
                                              objectName=="flexWrap"?wrapIcons[item]:
                                              item
                                              }
                                               </div>
                                                                             <div style={{position:"relative",fontSize:"16px",textAlign:"center"}}>{item}</div>
                                                                              </div>  
                                         <input type="radio" title="Set As Years"   checked={ itemValue==item?"yes":""}
                            className="input-textbox"   value={item}  name={objectName+"1"}    
                            onClick={e=>{
                callbackItemValue(item);
                   setItemValue(item);}}/>
                                 <span class={"boxCardBorder-two"}></span> </label>
                        
                        :""}
                                               </> ))} 
                        </div>
                              <div  style={{display:"flex",justifyContent:"left"}}>
                                                {items?.map((item,index)=>(
                                                 <> {index>=2&&index<4?  <label onMouseEnter={
                                                      ()=>handleMouseEnter("#fff","#333",item)}
                                       onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{paddingTop:"15px"}}>
                                                      <div style={{display:"flex",flexDirection: "row",gap:"5px",}} >
                                                       <div style={{display:"flex",justifyContent:"center"}}>
                                                     {
                                              objectName=="flexDirection"?flexDirectionIcons[item]:
                                              objectName=="justifyContent"?justifyContentIcons[item] :
                                              objectName=="alignItems"?alignItemsIcons[item]:
                                              objectName=="alignContent"?alignContentIcons[item]:
                                              objectName=="flexWrap"?wrapIcons[item]:
                                              item
                                              }
                                               </div>
                                                                             <div style={{position:"relative",fontSize:"16px",textAlign:"center"}}>{item}</div>
                                                                              </div>  
                                         <input type="radio" title="Set As Years"   checked={ itemValue==item?"yes":""}
                            className="input-textbox"   value={item}  name={objectName+"1"}    
                            onClick={e=>{
                callbackItemValue(item);
                   setItemValue(item);}}/>
                                 <span class={"boxCardBorder-two"}></span> </label>:""}
                                               </> ))} 
                        </div>
                         <div  style={{display:"flex",justifyContent:"left"}}>
                                                {items?.map((item,index)=>(
                                                 <> {index>=4&&index<6?  <label onMouseEnter={
                                                      ()=>handleMouseEnter("#fff","#333",item)}
                                       onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{paddingTop:"15px"}}>
                                                      <div style={{display:"flex",flexDirection: "row",gap:"5px",}} >
                                                       <div style={{display:"flex",justifyContent:"center"}}>
                                                     {
                                              objectName=="flexDirection"?flexDirectionIcons[item]:
                                              objectName=="justifyContent"?justifyContentIcons[item] :
                                              objectName=="alignItems"?alignItemsIcons[item]:
                                              objectName=="alignContent"?alignContentIcons[item]:
                                               objectName=="flexWrap"?wrapIcons[item]:
                                             item
                                              }
                                               </div>
                                                                             <div style={{position:"relative",fontSize:"16px",textAlign:"center"}}>{item}</div>
                                                                              </div>  
                                         <input type="radio" title="Set As Years"   checked={ itemValue==item?"yes":""}
                            className="input-textbox"   value={item}  name={objectName+"1"}    
                            onClick={e=>{
                callbackItemValue(item);
                   setItemValue(item);}}/>
                                 <span class={"boxCardBorder-two"}></span> </label>:""}
                                               </> ))} 
                        </div>
                          </div>
                       
                        </div> </div>
                                 </>)

    } 
    export default ItemSelectBoxesBigUI;

                     